import React, { useState } from 'react'
import { Grid, Button, Card, makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import ModalAbm from '../compartidos/abms/ModalAbm';
import { FormIngresoVersiones } from './FormIngresoVersiones';
import { USUARIOS_PERMISOS } from '../../utils/permisos';
import BuscadorAbm from '../compartidos/abms/BuscadorAbm';
import TableGeneric from '../compartidos/abms/TableGeneric';
import { BuscarVersionesSistema, FetchVersionesSistema, agregarVersionSistema } from '../../actions/versionado/versionadoActions';
import { validarSoloUnPermiso } from '../../helpers/permisos';


const useStyles = makeStyles({
    botonera: {
        padding: 25
    },
    root: {
        marginTop: 10
    }
});

export const HomeVersionesSistema = () => {

    const { items } = useSelector((state) => state.versionado);
    const { permisos: permisosUser } = useSelector(state => state.auth)
    const dispatch = useDispatch();
    const classes = useStyles();

    const [openAlta, setOpenAlta] = useState(false);

    useEffect(() => {
        dispatch(FetchVersionesSistema());
    }, [dispatch])

    const cerrarModalAlta = () => setOpenAlta(false)

    const handleSave = (item) => {
        console.log(item)
        const datos = {
            nroVersion: item.version,
            descripcion: item.descripcion
        }
        dispatch(agregarVersionSistema(datos))

    }

    const handleSearch = (textoBuscado) => {
        dispatch(BuscarVersionesSistema(textoBuscado));
    }

    return (
        <div className={classes.root}>
            <Grid container justify="center">
                <ModalAbm title="Agregar versión" open={openAlta} setOpen={setOpenAlta}>
                    <FormIngresoVersiones handleSave={handleSave} cerrarModal={cerrarModalAlta} permisoAlta={USUARIOS_PERMISOS.ALTA} />
                </ModalAbm>
                {validarSoloUnPermiso(permisosUser , USUARIOS_PERMISOS.ALTA) && (
                    <Grid item xs={12}>
                        <Button variant="contained" color="primary" onClick={() => setOpenAlta(true)} style={{ float: "right", marginTop: "1rem" }}>+ Agregar versión</Button>
                    </Grid>
                )}
                <Grid item xs={12} md={6} className={classes.root}>
                    <BuscadorAbm title="Buscar versiones" handleSearch={handleSearch} />
                </Grid>
                <Grid item xs={12} md={9} style={{ marginTop: "2rem" }} >
                    <Card>
                        <TableGeneric
                            data={items}
                            sizeTableCells={["10%", "90%"]}
                            align="left"
                            columns={[
                                {
                                    label: "Nro versión",
                                    id: "nroVersion",
                                    sort: true

                                },
                                {
                                    label: "Descripción",
                                    id: "descripcion",
                                    sort: true
                                }
                            ]}
                        />
                    </Card>
                </Grid>
            </Grid>
        </div>
    )
}
